import React from 'react';
import TopBar from '@/components/atelier/TopBar';
import Nav from '@/components/atelier/Nav';
import Footer from '@/components/atelier/Footer';
import EyebrowPill from '@/components/atelier/EyebrowPill';
import FinalCTACard from '@/components/atelier/FinalCTACard';
import { addJsonLd, buildServiceSchema, clearJsonLd, HAIRSALON_SCHEMA, getSiteSchemas } from '@/lib/seo';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import DynamicServiceFAQ from '@/components/services/DynamicServiceFAQ';

const BOOKING_URL = 'https://www.fresha.com/a/ikonomakis-hair-atelier-halandri-irakleitoy-80-bxynmijf?pId=770996';

const FAQ_ITEMS = [
  {
    question: "Τι είναι το airtouch;",
    answer: "Το airtouch είναι τεχνική ξανοίγματος όπου, πριν από το χρώμα, ο colorist περνά ροή αέρα από το πιστολάκι πάνω σε κάθε τούφα. Οι πιο λεπτές και κοντές τρίχες απομακρύνονται και ξανοίγονται μόνο οι πιο μακριές. Το αποτέλεσμα είναι πολύ ομαλή μετάβαση από τη ρίζα προς τις άκρες, χωρίς ορατή γραμμή.",
  },
  {
    question: "Πόσο κοστίζει το airtouch στο Χαλάνδρι;",
    answer: "Στο Ikonomakis Hair Atelier το airtouch ξεκινά από €200 για Hair Stylist / Colorist. Σε Color Expert η τιμή είναι +30–50% και σε Master Color Specialist +70–85%. Η τιμή είναι all-inclusive: διάγνωση, εφαρμογή, προστατευτικά K18 / Omniplex Farmavita, toner, λούσιμο και styling. Η τελική τιμή εξαρτάται από το μήκος και την πυκνότητα και επιβεβαιώνεται στη διάγνωση.",
  },
  {
    question: "Πόση ώρα διαρκεί;",
    answer: "Συνήθως 3 έως 5 ώρες, ανάλογα με το μήκος, την πυκνότητα και το πόσο θέλουμε να ανοίξει το μαλλί.",
  },
  {
    question: "Σε ποιον ταιριάζει το airtouch;",
    answer: "Ταιριάζει ιδιαίτερα σε μεσαία ή μακριά, πυκνά μαλλιά, από καστανά έως σκούρα, και σε όποιον θέλει φωτεινότητα με φυσική ρίζα και αραιά ραντεβού συντήρησης. Δουλεύει και πάνω σε παλιό balayage που θέλει πιο απαλή μετάβαση.",
  },
  {
    question: "Πότε δεν προτείνετε airtouch;",
    answer: "Σε πολύ λεπτά ή αραιά μαλλιά, όπου ο αέρας αφαιρεί πολλή τρίχα από την τούφα, και σε πολύ κοντά κουρέματα, προτείνουμε συνήθως babylights ή balayage. Σε πολύ ταλαιπωρημένα μαλλιά προτείνουμε πρώτα θεραπεία. Σε σκούρα βαφή κουτιού μπορεί να χρειαστεί πρώτα διόρθωση χρώματος.",
  },
  {
    question: "Ποια η διαφορά airtouch και balayage;",
    answer: "Το balayage ζωγραφίζεται με πινέλο ελεύθερα πάνω στην τούφα. Στο airtouch οι τρίχες που θα ξανοιχτούν επιλέγονται με τη ροή του αέρα, οπότε η μετάβαση είναι ακόμα πιο διάχυτη. Το airtouch χρειάζεται συνήθως περισσότερο χρόνο και κοστίζει από €200, ενώ το balayage από €150.",
  },
  {
    question: "Πόσο κρατάει το airtouch;",
    answer: "Επειδή η ρίζα μένει φυσική, η μετάβαση φαίνεται ωραία για 5–7 μήνες. Ένα gloss/toner ενδιάμεσα κρατά τον τόνο καθαρό και τη λάμψη ζωντανή.",
  },
  {
    question: "Καταπονεί τα μαλλιά;",
    answer: "Κάθε ξάνοιγμα επηρεάζει την τρίχα. Γι' αυτό ξεκινάμε με διάγνωση, χρησιμοποιούμε προστατευτικά K18 και Omniplex Farmavita σε όλη τη διαδικασία και κλείνουμε με θεραπεία. Αν η τρίχα δεν αντέχει, σου το λέμε πριν ξεκινήσουμε.",
  },
  {
    question: "Γίνεται σε βαμμένα ή σκούρα μαλλιά;",
    answer: "Ναι, σε πολλές περιπτώσεις. Σε φυσικά σκούρα μαλλιά το airtouch δίνει πολύ ωραίο αποτέλεσμα. Σε μαλλιά με σκούρα βαφή, η διάγνωση θα δείξει αν μπορούμε να ξεκινήσουμε κατευθείαν ή αν χρειάζεται πρώτα διόρθωση χρώματος.",
  },
  {
    question: "Μιλάτε αγγλικά;",
    answer: "Ναι, η ομάδα εξυπηρετεί στα ελληνικά και στα αγγλικά. Yes, we speak English — you can book online or call 211 800 4132.",
  },
];

export default function AirtouchHubPage() {
  useEffect(() => {
    clearJsonLd();
    getSiteSchemas().forEach(addJsonLd);
    addJsonLd(HAIRSALON_SCHEMA);
    addJsonLd(buildServiceSchema({ name: 'Airtouch', description: 'Τεχνική airtouch στο Χαλάνδρι — hand-painted χρώμα με ροή αέρα για φυσική, σταδιακή μετάβαση. Master Color Specialists, Ikonomakis Hair Atelier.', priceFrom: 200, url: '/services/airtouch' }));
    addJsonLd({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://ikonomakis.gr/' },
        { '@type': 'ListItem', position: 2, name: 'Υπηρεσίες', item: 'https://ikonomakis.gr/services' },
        { '@type': 'ListItem', position: 3, name: 'Airtouch Χαλάνδρι', item: 'https://ikonomakis.gr/services/airtouch' },
      ],
    });

  }, []);

  return (
    <div className="bg-cream-bg text-warm-black min-h-screen">
      <TopBar />
      <Nav />

      {/* Breadcrumb */}
      <div className="px-[6vw] py-4 bg-cream-soft/40 border-b border-brown/10">
        <div className="max-w-container mx-auto text-tiny text-muted/80 flex gap-2 flex-wrap">
          <a href="/" className="hover:text-warm-black">Home</a><span>/</span>
          <a href="/services" className="hover:text-warm-black">Υπηρεσίες</a><span>/</span>
          <span className="text-warm-black">Airtouch</span>
        </div>
      </div>

      <main>
        {/* Hero */}
        <section className="px-[6vw] pt-[80px] pb-[70px] bg-ivory">
          <div className="max-w-container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div>
              <EyebrowPill variant="dark" className="mb-6">Τεχνική Airtouch · Χαλάνδρι</EyebrowPill>
              <h1 className="font-serif text-display-l text-warm-black font-medium tracking-[-2px] leading-[0.95] mb-6">
                Airtouch —<br /><em className="italic text-gold">φως που αναπνέει.</em>
              </h1>
              <p className="text-body-l text-muted leading-[1.65] max-w-[540px] mb-8">
                Η τεχνική που χρησιμοποιεί ροή αέρα για να δημιουργήσει το πιο φυσικό, αδιόρατο gradient που έχεις δει. Ιδανική για σκούρα, πυκνά μαλλιά με μηδενική ορατή ρίζα.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 rounded-pill bg-warm-black text-cream font-medium text-body-s hover:bg-brown transition-colors">
                  Κράτηση Online →
                </a>
                <Link to="/services/hair-color" className="inline-flex items-center gap-2 px-8 py-4 rounded-pill border border-brown/30 text-warm-black font-medium text-body-s hover:border-warm-black transition-colors">
                  Όλες οι υπηρεσίες χρώματος
                </Link>
              </div>
            </div>
            <img
              src="https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=1200&q=80"
              alt="Airtouch τεχνική χρωματισμού μαλλιών — φυσικό gradient αποτέλεσμα στο Ikonomakis Hair Atelier Χαλάνδρι"
              className="w-full rounded-card-l object-cover"
              style={{ aspectRatio: '4/3' }}
              loading="eager"
            />
          </div>
        </section>

        {/* Με μια ματιά — answer-first block for people and AI assistants */}
        <section className="px-[6vw] py-[60px] bg-cream-soft border-y border-brown/10" aria-labelledby="airtouch-at-a-glance">
          <div className="max-w-container mx-auto">
            <h2 id="airtouch-at-a-glance" className="font-serif text-h2 text-warm-black font-medium mb-4">Airtouch στο Χαλάνδρι — με μια ματιά</h2>
            <p className="text-body text-muted leading-[1.75] max-w-reading mb-8">
              Στο Ikonomakis Hair Atelier (Ηρακλείτου 80, Χαλάνδρι) το airtouch ξεκινά από <strong className="text-warm-black">€200 all-inclusive</strong>, διαρκεί <strong className="text-warm-black">3–5 ώρες</strong> και κρατά <strong className="text-warm-black">5–7 μήνες</strong> πριν χρειαστεί ανανέωση. Κάθε ραντεβού ξεκινά με διάγνωση και γίνεται με προστατευτικά K18 και Omniplex Farmavita. Εξυπηρετούμε στα ελληνικά και στα αγγλικά.
            </p>
            <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {[
                ['Τιμή', 'από €200 (Hair Stylist / Colorist) · Color Expert +30–50% · Master +70–85%'],
                ['Διάρκεια ραντεβού', '3–5 ώρες, ανάλογα με μήκος και πυκνότητα'],
                ['Πόσο κρατά', '5–7 μήνες, με gloss/toner ενδιάμεσα'],
                ['Περιλαμβάνει', 'Διάγνωση, εφαρμογή, K18 / Omniplex Farmavita, toner, λούσιμο, styling'],
                ['Ιδανικό για', 'Μεσαία–μακριά, πυκνά, καστανά έως σκούρα μαλλιά'],
                ['Γλώσσες', 'Ελληνικά & αγγλικά · 211 800 4132'],
              ].map(([term, desc]) => (
                <div key={term} className="p-5 rounded-card bg-ivory border border-brown/10">
                  <dt className="text-tiny uppercase tracking-widest text-gold mb-1">{term}</dt>
                  <dd className="text-body-s text-warm-black leading-relaxed">{desc}</dd>
                </div>
              ))}
            </dl>
          </div>
        </section>

        {/* Τι είναι */}
        <section className="px-[6vw] py-[90px] bg-cream-bg">
          <div className="max-w-reading mx-auto">
            <EyebrowPill variant="gold-soft" className="mb-6">Η Τεχνική</EyebrowPill>
            <h2 className="font-serif text-display-s text-warm-black font-medium tracking-[-1.5px] mb-6">Τι είναι το Airtouch;</h2>
            <div className="space-y-5 text-body-l text-muted leading-[1.75]">
              <p>
                Το <strong className="text-warm-black">airtouch</strong> είναι μια προηγμένη τεχνική hand-painted χρωματισμού μαλλιών που αναπτύχθηκε ως εξέλιξη του balayage. Αντί να χρησιμοποιεί αποκλειστικά πινέλο, ο ειδικός κατευθύνει ροή αέρα πάνω σε κάθε τούφα πριν εφαρμόσει το χρώμα — αυτό απομακρύνει τις λεπτότερες τρίχες και αφήνει εκτεθειμένες μόνο τις πιο δυνατές, πιο χοντρές τρίχες.
              </p>
              <p>
                Το αποτέλεσμα είναι ένα <strong className="text-warm-black">εξαιρετικά φυσικό, σταδιακό gradient φωτεινότητας</strong> που μοιάζει σαν να έχουν ξανοίξει τα μαλλιά φυσικά από τον ήλιο. Δεν υπάρχει ορατή γραμμή διαχωρισμού, δεν υπάρχει πτώση από σκούρο σε ανοιχτό — μόνο μια ρευστή, αδιόρατη μετάβαση.
              </p>
              <p>
                Το airtouch είναι ιδανικό για <strong className="text-warm-black">πυκνά, σκούρα μαλλιά</strong> που θέλουν subtlе φωτεινότητα χωρίς να "προδοθεί" η τεχνητή επέμβαση. Ταιριάζει επίσης σε ήδη balayaged μαλλιά που θέλουν πιο soft, diffused αποτέλεσμα από ανανέωση.
              </p>
            </div>
          </div>
        </section>

        {/* Σε ποιον ταιριάζει */}
        <section className="px-[6vw] py-[80px] bg-cream-soft">
          <div className="max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
            <div>
              <EyebrowPill variant="gold-soft" className="mb-6">Υποψηφιότητα</EyebrowPill>
              <h2 className="font-serif text-display-s text-warm-black font-medium tracking-[-1.5px] mb-6">Σε ποιον ταιριάζει;</h2>
              <div className="space-y-4 text-body text-muted leading-[1.75]">
                <p>Η τεχνική airtouch ταιριάζει ιδανικά σε:</p>
                <ul className="space-y-3">
                  {[
                    'Πυκνά και σκούρα μαλλιά (καστανό, μαύρο) που θέλουν φυσική φωτεινότητα',
                    'Μαλλιά που έχουν ήδη balayage και θέλουν πιο soft αποτέλεσμα',
                    'Γυναίκες/άνδρες που δεν θέλουν ορατή ρίζα ανάμεσα στις επισκέψεις',
                    'Μαλλιά που έχουν εφαρμοστεί θεραπείες κερατίνης ή άλλα πρωτόκολλα',
                    'Όποιον θέλει low-maintenance χρώμα με μέγιστη διάρκεια',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="text-gold mt-0.5 flex-shrink-0">✦</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <p className="pt-2">
                  Δεν ταιριάζει σε πολύ λεπτά, αδύνατα μαλλιά όπου δεν υπάρχει επαρκής πυκνότητα τρίχας για τη διαδικασία — σε αυτές τις περιπτώσεις, το <Link to="/services/hair-color" className="text-gold hover:text-gold-dark underline underline-offset-2">balayage ή τα babylights</Link> είναι η καλύτερη επιλογή.
                </p>
              </div>
            </div>
            <div className="space-y-5">
              <h3 className="font-serif text-h2 text-warm-black font-medium">Airtouch vs Balayage — οι βασικές διαφορές</h3>
              <div className="overflow-hidden rounded-card border border-brown/10">
                <table className="w-full text-body-s">
                  <thead>
                    <tr className="bg-warm-black text-cream">
                      <th className="text-left px-5 py-3 font-medium">Χαρακτηριστικό</th>
                      <th className="text-left px-5 py-3 font-medium">Airtouch</th>
                      <th className="text-left px-5 py-3 font-medium">Balayage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ['Τεχνική', 'Ροή αέρα + πινέλο', 'Χειρωνακτικό painting'],
                      ['Αποτέλεσμα', 'Πιο φυσικό, diffused', 'Πιο visible, graphic'],
                      ['Ιδανικό για', 'Πυκνά, σκούρα μαλλιά', 'Κάθε τύπο μαλλιού'],
                      ['Διάρκεια', '5–7 μήνες', '4–6 μήνες'],
                      ['Τιμή από', '€200', '€150'],
                    ].map(([char, air, bal], i) => (
                      <tr key={char} className={i % 2 === 0 ? 'bg-ivory' : 'bg-cream-bg'}>
                        <td className="px-5 py-3 text-muted font-medium">{char}</td>
                        <td className="px-5 py-3 text-warm-black">{air}</td>
                        <td className="px-5 py-3 text-muted">{bal}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        {/* Διαδικασία + Τιμή + Συντήρηση */}
        <section className="px-[6vw] py-[90px] bg-cream-bg">
          <div className="max-w-reading mx-auto">
            <EyebrowPill variant="gold-soft" className="mb-6">Διαδικασία & Τιμή</EyebrowPill>
            <h2 className="font-serif text-display-s text-warm-black font-medium tracking-[-1.5px] mb-8">Τι να περιμένετε</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {[
                { step: '01', title: 'Διάγνωση', text: 'Εξετάζουμε το ιστορικό χρώματος, την πυκνότητα και την αντοχή της τρίχας, και συζητάμε το αποτέλεσμα που θέλεις με φωτογραφίες αναφοράς.' },
                { step: '02', title: 'Σχέδιο φωτεινότητας', text: 'Αποφασίζουμε πόσο θα ανοίξει το μαλλί, πού θα πέφτει το φως γύρω από το πρόσωπο και πόσο φυσική θα μείνει η ρίζα.' },
                { step: '03', title: 'Διαχωρισμός με αέρα', text: 'Σε κάθε τούφα, η ροή του αέρα απομακρύνει τις κοντές και λεπτές τρίχες. Μένουν μόνο αυτές που θα ξανοιχτούν, για αδιόρατη μετάβαση.' },
                { step: '04', title: 'Ξάνοιγμα με προστασία', text: 'Το ξάνοιγμα γίνεται με προστατευτικά K18 και Omniplex Farmavita, ώστε η τρίχα να μένει δυνατή σε όλη τη διαδικασία.' },
                { step: '05', title: 'Toner & gloss', text: 'Ρυθμίζουμε τον τόνο (μπεζ, honey, ψυχρό ξανθό) και ενώνουμε ρίζα, μήκος και άκρες σε ένα συνεχές gradient.' },
                { step: '06', title: 'Θεραπεία, styling & οδηγίες', text: 'Θεραπεία, λούσιμο, styling και προσωπικό πλάνο φροντίδας για το σπίτι. Όλα περιλαμβάνονται στην τιμή.' },
              ].map((s) => (
                <div key={s.step} className="p-6 bg-ivory rounded-card border border-brown/10">
                  <div className="font-serif text-[36px] text-gold/30 font-medium leading-none mb-3">{s.step}</div>
                  <h3 className="font-semibold text-warm-black text-body-s mb-2">{s.title}</h3>
                  <p className="text-tiny text-muted leading-relaxed">{s.text}</p>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
              {[
                { label: 'Τιμή από', value: '€200' },
                { label: 'Διάρκεια', value: '3–5 ώρες' },
                { label: 'Συντήρηση', value: 'κάθε 5–7 μήνες' },
              ].map((info) => (
                <div key={info.label} className="p-6 rounded-card-xl bg-warm-black text-center">
                  <div className="text-tiny uppercase tracking-widest text-cream/60 mb-1">{info.label}</div>
                  <div className="font-serif text-[32px] text-gold-light font-medium">{info.value}</div>
                </div>
              ))}
            </div>
            <div className="space-y-4 text-body text-muted leading-[1.75]">
              <h3 className="font-serif text-h2 text-warm-black">Συντήρηση airtouch — το πρόγραμμα</h3>
              <ul className="space-y-3">
                {[
                  ['Πρώτες 48 ώρες', 'Απόφυγε το λούσιμο, για να «κλειδώσει» ο τόνος.'],
                  ['Κάθε εβδομάδα', 'Σαμπουάν και conditioner για βαμμένα μαλλιά, θερμοπροστασία πριν από πιστολάκι ή πρέσα.'],
                  ['Κάθε 2–3 εβδομάδες', 'Μάσκα αναδόμησης στο σπίτι.'],
                  ['Στις 6–10 εβδομάδες', 'Gloss/toner 45 λεπτών στο atelier για καθαρό τόνο και λάμψη.'],
                  ['Στους 5–7 μήνες', 'Ανανέωση airtouch, όταν το θέλεις — η ρίζα μεγαλώνει φυσικά.'],
                ].map(([when, what]) => (
                  <li key={when} className="flex items-start gap-3">
                    <span className="text-gold mt-0.5 flex-shrink-0">✦</span>
                    <span><strong className="text-warm-black">{when}:</strong> {what}</span>
                  </li>
                ))}
              </ul>
              <p>
                Μετά το airtouch, το πρόγραμμα φροντίδας στο σπίτι είναι απλό: χρησιμοποιείτε <strong className="text-warm-black">σαμπουάν και conditioner για βαμμένα μαλλιά</strong>, αποφεύγετε τη συχνή έκθεση στον ήλιο χωρίς προστασία, και κάνετε <Link to="/services/hair-treatments" className="text-gold hover:text-gold-dark underline underline-offset-2">μάσκα αναδόμησης</Link> κάθε 2–3 εβδομάδες.
              </p>
              <p>
                Για να διατηρηθεί η λάμψη και ο τόνος ανάμεσα στις επισκέψεις, προτείνουμε <strong className="text-warm-black">glossing session</strong> — μια γρήγορη θεραπεία 45 λεπτών που ανανεώνει τη λάμψη και τονίζει τη μετάβαση χωρίς κόστος πλήρους εφαρμογής.
              </p>
            </div>
          </div>
        </section>

        {/* Πριν / Μετά placeholder */}
        <section className="px-[6vw] py-[70px] bg-cream-soft">
          <div className="max-w-container mx-auto">
            <EyebrowPill variant="gold-soft" className="mb-6">Αποτελέσματα</EyebrowPill>
            <h2 className="font-serif text-display-s text-warm-black font-medium tracking-[-1.5px] mb-8">Airtouch — αποτέλεσμα και έμπνευση</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {[
                { src: 'https://media.base44.com/images/public/69d96446735f4e1f0f7d5bbf/36bc2da29_IMG_7188.jpg', caption: 'Καστανό → Soft blonde gradient', alt: 'Airtouch αποτέλεσμα — μετάβαση από καστανό σε soft blonde gradient, Ikonomakis Hair Atelier Χαλάνδρι' },
                { src: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=800&q=80', caption: 'Έμπνευση — ενδεικτική φωτογραφία, όχι εργασία του atelier', alt: 'Ενδεικτική φωτογραφία μαλλιών για έμπνευση χρώματος' },
                { src: 'https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?auto=format&fit=crop&w=800&q=80', caption: 'Έμπνευση τόνου — ενδεικτική φωτογραφία, όχι εργασία του atelier', alt: 'Ενδεικτική φωτογραφία για έμπνευση απόχρωσης μαλλιών' },
              ].map((img) => (
                <div key={img.src} className="rounded-card overflow-hidden">
                  <img src={img.src} alt={img.alt || img.caption} className="w-full object-cover" style={{ aspectRatio: '3/4' }} loading="lazy" />
                  <div className="px-4 py-3 bg-ivory text-tiny text-muted">{img.caption}</div>
                </div>
              ))}
            </div>
            <div className="mt-6">
              <Link to="/before-after" className="inline-flex items-center gap-2 text-body-s text-gold hover:text-gold-dark transition-colors underline underline-offset-2">
                Δείτε όλες τις μεταμορφώσεις μαλλιών →
              </Link>
            </div>
          </div>
        </section>

        {/* Internal links — Journal */}
        <section className="px-[6vw] py-[60px] bg-ivory">
          <div className="max-w-container mx-auto">
            <h3 className="font-serif text-h2 text-warm-black font-medium mb-6">Σχετικά άρθρα από το Journal</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {[
                { label: 'Τι είναι το balayage και πώς διαφέρει από τα highlights', href: '/ti-einai-to-balayage' },
                { label: 'Πόσο κρατάει το χρώμα στα μαλλιά — οδηγός συντήρησης', href: '/pos-na-diatirisis-to-xroma-sou' },
                { label: 'Balayage vs highlights — ποιο να επιλέξεις;', href: '/balayage-vs-highlights' },
              ].map((article) => (
                <Link key={article.href} to={article.href} className="p-5 rounded-card bg-cream-bg border border-brown/10 hover:border-gold/30 transition-colors group">
                  <span className="text-tiny uppercase tracking-widest text-gold mb-2 block">Journal</span>
                  <span className="font-serif text-[17px] text-warm-black group-hover:text-gold transition-colors leading-snug">{article.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="px-[6vw] py-[90px] bg-cream-bg">
          <div className="max-w-reading mx-auto">
            <EyebrowPill variant="dark" className="mb-6">Συχνές Ερωτήσεις</EyebrowPill>
            <h2 className="font-serif text-display-s text-warm-black font-medium tracking-[-1.5px] mb-8">Airtouch — τι θέλεις να ξέρεις</h2>
            <DynamicServiceFAQ path="/services/airtouch" fallback={FAQ_ITEMS} />
            <div className="mt-8">
              <Link to="/faq" className="text-body-s text-gold hover:text-gold-dark underline underline-offset-2 transition-colors">
                Δείτε όλες τις συχνές ερωτήσεις →
              </Link>
            </div>
          </div>
        </section>

        {/* Related services */}
        <section className="px-[6vw] py-[60px] bg-cream-soft">
          <div className="max-w-container mx-auto">
            <h3 className="font-serif text-h2 text-warm-black font-medium mb-6">Σχετικές υπηρεσίες</h3>
            <div className="flex flex-wrap gap-3">
              {[
                { label: 'Balayage Χαλάνδρι', href: '/balayage-chalandri' },
                { label: 'Babylights', href: '/services/babylights' },
                { label: 'Color Correction', href: '/color-correction-chalandri' },
                { label: 'Blonde Specialist', href: '/blonde-specialist-chalandri' },
                { label: 'Θεραπείες Μαλλιών', href: '/services/hair-treatments' },
                { label: 'Όλο το χρώμα →', href: '/services/hair-color' },
              ].map((item) => (
                <Link key={item.href} to={item.href} className="px-5 py-2.5 rounded-pill border border-brown/20 text-tiny text-warm-black hover:border-warm-black transition-colors">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="px-[6vw] py-[90px] bg-cream-bg">
          <FinalCTACard
            title="Ζήστε το"
            titleEm="Airtouch."
            description="Κλείστε consultation online για να σχεδιάσουμε μαζί το gradient που σας ταιριάζει — με διαφανή τιμολόγηση και zero κρυφές χρεώσεις."
            ctaText="Κράτηση Online →"
            ctaHref={BOOKING_URL}
            ctaTarget="_blank"
            ctaRel="noopener noreferrer"
          />
        </section>
      </main>

      <Footer />
    </div>
  );
}